module.exports = __webpack_public_path__ + "ClientApp/images/content/block-rich-resources/How-will-I-know-its-time.jpg";